// extracted by mini-css-extract-plugin
export default {"CircularProgressContainer":"LoadingWidget_CircularProgressContainer__w63-T"};